import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, FileQuestion, Building, Shield } from 'lucide-react';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-sunbeth-orange-50 to-sunbeth-orange-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        <div>
          <div className="mx-auto h-16 w-16 flex items-center justify-center">
            <img
              src="/logo192.png"
              alt="Sunbeth Global Concepts"
              className="h-16 w-16 object-contain"
            />
          </div>
          <p className="mt-2 text-sm text-gray-600">Sunbeth Global Concepts Limited</p>
        </div>

        <div className="bg-white py-8 px-6 shadow-xl rounded-xl">
          <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-sunbeth-orange-100 mb-6">
            <FileQuestion className="h-10 w-10 text-sunbeth-orange-600" />
          </div>

          <p className="text-7xl font-extrabold text-sunbeth-orange-600 tracking-tight">404</p>
          <h1 className="mt-4 text-2xl font-bold text-gray-900">Page not found</h1>
          <p className="mt-3 text-sm text-gray-600 leading-relaxed">
            The page you are looking for does not exist or may have been moved.
            Check the URL or use one of the links below to get back on track.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors"
            >
              <ArrowLeft className="h-4 w-4" />
              Go back
            </button>
            <Link
              to="/vendor/register"
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md text-sm font-medium text-white bg-sunbeth-orange-600 hover:bg-sunbeth-orange-700 transition-colors"
            >
              <Home className="h-4 w-4" />
              Vendor registration
            </Link>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-100">
            <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-4">
              Quick links
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-left">
              <Link
                to="/vendor/login"
                className="flex items-center gap-3 p-3 rounded-lg border border-gray-200 hover:border-sunbeth-orange-300 hover:bg-sunbeth-orange-50 transition-colors group"
              >
                <Building className="h-5 w-5 text-sunbeth-orange-600 flex-shrink-0" />
                <div>
                  <p className="text-sm font-medium text-gray-900 group-hover:text-sunbeth-orange-700">
                    Vendor login
                  </p>
                  <p className="text-xs text-gray-500">Access your vendor dashboard</p>
                </div>
              </Link>
              <Link
                to="/staff/login"
                className="flex items-center gap-3 p-3 rounded-lg border border-gray-200 hover:border-sunbeth-orange-300 hover:bg-sunbeth-orange-50 transition-colors group"
              >
                <Shield className="h-5 w-5 text-sunbeth-orange-600 flex-shrink-0" />
                <div>
                  <p className="text-sm font-medium text-gray-900 group-hover:text-sunbeth-orange-700">
                    Staff login
                  </p>
                  <p className="text-xs text-gray-500">Sign in with Microsoft 365</p>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
